export const SLIM_MINIMUM_APPLICANT_AGE = 15;

const CALENDAR_DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * Normalize API / form values to a calendar date string (YYYY-MM-DD) without
 * local timezone shifting (fixes DOB appearing one day off in date inputs).
 */
export function toCalendarDateString(value) {
  if (!value) return '';

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const y = value.getUTCFullYear();
    const m = String(value.getUTCMonth() + 1).padStart(2, '0');
    const d = String(value.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  const str = String(value).trim();
  const match = str.match(CALENDAR_DATE_PREFIX);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  const parsed = new Date(str);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }

  return toCalendarDateString(parsed);
}

/** Format a calendar date for display in the user's locale. */
export function formatCalendarDateForDisplay(value, locale) {
  const iso = toCalendarDateString(value);
  if (!iso) return '';

  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(locale);
}

/**
 * Latest allowed date of birth for SLIM applicants (must be over minimumAge years old).
 * Uses 31 December of the calendar year that is minimumAge years before referenceDate.
 */
export function getMaxApplicantDateOfBirth(
  referenceDate = new Date(),
  minimumAge = SLIM_MINIMUM_APPLICANT_AGE
) {
  const ref = referenceDate instanceof Date ? referenceDate : new Date(referenceDate);
  const year = ref.getFullYear() - minimumAge;
  return `${year}-12-31`;
}

export function isApplicantDateOfBirthAllowed(dateOfBirth, maxDateOfBirth) {
  if (!dateOfBirth || !maxDateOfBirth) return false;
  return String(dateOfBirth).slice(0, 10) <= maxDateOfBirth;
}

export function getApplicantDateOfBirthError(maxDateOfBirth) {
  return `Applicants must be at least ${SLIM_MINIMUM_APPLICANT_AGE} years old (date of birth on or before ${maxDateOfBirth}).`;
}
